export const HOME_URL = '/'
export const PROFILE_URL = 'profile'
export const LOGIN_URL = 'login'
export const SIGNUP_URL = 'signup'
export const RESETPASSWORD_URL = 'resetpassword'